export default __webpack_public_path__ + "static/Logo Placement – Mobility – 1280px-b35540ab76fcc561dd14d47989079edd.jpg";